var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 0.166656C9.49984 0.166656 0.166504 9.49999 0.166504 21C0.166504 32.5 9.49984 41.8333 20.9998 41.8333C32.4998 41.8333 41.8332 32.5 41.8332 21C41.8332 9.49999 32.4998 0.166656 20.9998 0.166656ZM16.8332 31.4167L6.4165 21L9.354 18.0625L16.8332 25.5208L32.6457 9.70832L35.5832 12.6667L16.8332 31.4167Z",
    fill: "#FF00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccessIcon);
export default __webpack_public_path__ + "static/media/modal-success-icon.84926ea557db980f6b16e01153b692fe.svg";
export { ForwardRef as ReactComponent };